module.exports = __webpack_public_path__ + "static/media/rectangle-12.1019bafb.svg";